import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

export default function Ancor({ data }) {
  const id_ancor = get(data, 'id_ancor', null)

  if (id_ancor) return <section id={id_ancor} />

  return null
}

Ancor.propTypes = {
  data: PropTypes.object,
}
